export default __webpack_public_path__ + "static/media/medium.f23c5594.svg";